/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';
import noop from 'lodash/noop';

import { ContentModuleModal, SortableList, TextField } from '@molecules';
import { Typography } from '@atoms';
import { NO_MARGIN_BOTTOM } from '@constants';
import { getImage } from '@utils/media';

import Form from '../Form';

import ScrollForm from './ScrollForm';
import SlideItem from './ScrollItem';
import CarouselItem from './Item';
import { SLIDES, SCROLL_NEWS_PANEL_INITS, FORM_PANEL } from './constant';
import s from './styles.module.less';

const ScrollNewsPanel = ({ visible = true, previewImg, onSubmit, hide, onDelete, initialValues: initData, errors }) => {
  const [form] = Form.useForm(FORM_PANEL);

  const initialValues = React.useMemo(() => form.deserialize(initData || SCROLL_NEWS_PANEL_INITS), [form, initData]);

  const [slides, setSlides] = React.useState(initialValues[SLIDES.name]);

  const syncSlides = React.useCallback(
    (_slides) => {
      form.setFields([{ name: SLIDES.name, value: _slides }]);
      setSlides(_slides);
    },
    [form, setSlides],
  );

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleAdd = React.useCallback((slide) => syncSlides([slide, ...(form.getFieldValue(SLIDES.name) || [])]), [
    form,
    syncSlides,
  ]);

  return (
    <ContentModuleModal
      subtitle="Add items to appear in the page’s scroll news. You can choose up to 6 items."
      okText={onDelete ? 'SAVE CHANGES' : 'ADD SCROLL NEWS PANEL'}
      heroImageSrc={previewImg}
      title="Scroll News Panel"
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      visible={visible}
      errors={errors}
    >
      <Typography.Title level={3}>Add a slide</Typography.Title>
      <ScrollForm onSubmit={handleAdd} className={s.addForm} />
      <SortableList
        style={NO_MARGIN_BOTTOM}
        label="Current slides"
        onChange={syncSlides}
        withPlaceholder
        value={slides}
        withCount
      >
        {(value, { edit, isEdit, save, buttons }) =>
          isEdit ? (
            <ScrollForm onSubmit={save} initialValues={value} buttons={buttons} />
          ) : (
            <SlideItem
              image={getImage(value.article || value, value.article ? 'featureImage' : 'image')}
              description={value.subheadline}
              handleEdit={edit}
            >
              {value?.headline}
            </SlideItem>
          )
        }
      </SortableList>

      <Form onSerializedFinish={handleSubmit} initialValues={initialValues} layout="vertical" form={form}>
        <Form.List className={s.listItem} {...SLIDES}>
          {noop}
        </Form.List>
        <TextField {...FORM_PANEL.TITLE} style={{ margin: '20px 0' }} />
        <TextField {...FORM_PANEL.MORE_NEWS_LINK} />
        <TextField {...FORM_PANEL.MORE_NEWS_TEXT} />
      </Form>
    </ContentModuleModal>
  );
};

ScrollNewsPanel.Item = CarouselItem;

export default ScrollNewsPanel;
